import { z } from 'zod';
import { transcriptionProviderSchema } from './enums.js';
export const transcriptSegmentSchema = z.object({
    id: z.string(),
    idx: z.number(),
    speaker: z.string(),
    startSec: z.number(),
    endSec: z.number(),
    text: z.string(),
    language: z.string().nullable(),
    confidence: z.number().nullable(),
});
export const transcriptResponseSchema = z.object({
    transcript: z
        .object({
        id: z.string(),
        provider: z.string(),
        model: z.string(),
        version: z.number(),
        fullText: z.string(),
        costUsd: z.number().nullable(),
        createdAt: z.string(),
    })
        .nullable(),
    segments: z.array(transcriptSegmentSchema),
    audioUrl: z.string().nullable(),
});
export const updateSegmentInputSchema = z
    .object({
    text: z.string().max(5000).optional(),
    speaker: z.string().max(120).optional(),
})
    .refine((v) => v.text !== undefined || v.speaker !== undefined, {
    message: 'text or speaker is required',
});
export const speakerMappingSchema = z.object({
    from: z.string().min(1).max(120),
    to: z.string().min(1).max(120),
    attendeeId: z.string().nullish(),
});
export const updateSpeakersInputSchema = z.object({
    mappings: z.array(speakerMappingSchema).min(1).max(30),
});
export const retranscribeInputSchema = z.object({
    provider: transcriptionProviderSchema.optional(),
});
//# sourceMappingURL=transcripts.js.map